
import { CommonCellProps } from '../cell/mixins/common-cell-props';
import { GridSizeStylesProps } from '../../../mixins/grid-size-styles';
import { GridColumnType } from '../../../enums';
import GridBodyRowCellDate from '../cell/cell-date';
import GridBodyRowCellNumber from '../cell/cell-number';
import GridBodyRowCellText from '../cell/cell-text';
import GridBodyRowCellMoney from '../cell/cell-money';
import GridBodyRowCellCustom from '../cell/cell-custom';

export default {
  name: 'GridBodyRowCellFactory',
  mixins: [CommonCellProps, GridSizeStylesProps],
  props: {
    column: {
      required: true,
      type: Object,
    },
  },
  methods: {
    getCellComponent(columnType) {
      switch (columnType) {
        case GridColumnType.Date:
          return GridBodyRowCellDate;
        case GridColumnType.Number:
          return GridBodyRowCellNumber;
        case GridColumnType.Money:
          return GridBodyRowCellMoney;
        case GridColumnType.Custom:
          return GridBodyRowCellCustom;
        case GridColumnType.Text:
        default:
          return GridBodyRowCellText;
      }
    },
  },
};
